"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.decodeFlag = decodeFlag;
exports.decodeVariations = decodeVariations;
exports.decodeValue = decodeValue;
exports.decodeAllocation = decodeAllocation;
exports.decodeSplit = decodeSplit;
exports.decodeShard = decodeShard;
exports.decodeObject = decodeObject;
exports.decodeObjectTo = decodeObjectTo;
exports.decodePrecomputedFlag = decodePrecomputedFlag;
exports.decodePrecomputedBandit = decodePrecomputedBandit;
const interfaces_1 = require("./interfaces");
const obfuscation_1 = require("./obfuscation");
function decodeFlag(flag) {
    return {
        ...flag,
        variations: decodeVariations(flag.variations, flag.variationType),
        allocations: flag.allocations.map(decodeAllocation),
    };
}
function decodeVariations(variations, variationType) {
    return Object.fromEntries(Object.entries(variations).map(([, variation]) => {
        const decodedKey = (0, obfuscation_1.decodeBase64)(variation.key);
        return [decodedKey, { key: decodedKey, value: decodeValue(variation.value, variationType) }];
    }));
}
function decodeValue(encodedValue, type) {
    switch (type) {
        case interfaces_1.VariationType.INTEGER:
        case interfaces_1.VariationType.NUMERIC:
            return Number((0, obfuscation_1.decodeBase64)(encodedValue));
        case interfaces_1.VariationType.BOOLEAN:
            return (0, obfuscation_1.decodeBase64)(encodedValue) === 'true';
        default:
            return (0, obfuscation_1.decodeBase64)(encodedValue);
    }
}
function decodeAllocation(allocation) {
    return {
        ...allocation,
        key: (0, obfuscation_1.decodeBase64)(allocation.key),
        splits: allocation.splits.map(decodeSplit),
        startAt: allocation.startAt
            ? new Date((0, obfuscation_1.decodeBase64)(allocation.startAt)).toISOString()
            : undefined,
        endAt: allocation.endAt ? new Date((0, obfuscation_1.decodeBase64)(allocation.endAt)).toISOString() : undefined,
    };
}
function decodeSplit(split) {
    return {
        extraLogging: split.extraLogging ? decodeObject(split.extraLogging) : undefined,
        variationKey: (0, obfuscation_1.decodeBase64)(split.variationKey),
        shards: split.shards.map(decodeShard),
    };
}
function decodeShard(shard) {
    return {
        ...shard,
        salt: (0, obfuscation_1.decodeBase64)(shard.salt),
    };
}
function decodeObject(obj) {
    return decodeObjectTo(obj, (v) => v);
}
function decodeObjectTo(obj, transform) {
    return Object.fromEntries(Object.entries(obj).map(([key, value]) => [(0, obfuscation_1.decodeBase64)(key), transform((0, obfuscation_1.decodeBase64)(value))]));
}
function decodePrecomputedFlag(precomputedFlag) {
    return {
        ...precomputedFlag,
        allocationKey: (0, obfuscation_1.decodeBase64)(precomputedFlag.allocationKey ?? ''),
        variationKey: (0, obfuscation_1.decodeBase64)(precomputedFlag.variationKey ?? ''),
        variationValue: decodeValue(precomputedFlag.variationValue, precomputedFlag.variationType),
        extraLogging: decodeObject(precomputedFlag.extraLogging ?? {}),
    };
}
function decodePrecomputedBandit(precomputedBandit) {
    return {
        ...precomputedBandit,
        banditKey: (0, obfuscation_1.decodeBase64)(precomputedBandit.banditKey),
        action: (0, obfuscation_1.decodeBase64)(precomputedBandit.action),
        modelVersion: (0, obfuscation_1.decodeBase64)(precomputedBandit.modelVersion),
        actionNumericAttributes: decodeObjectTo(precomputedBandit.actionNumericAttributes ?? {}, (v) => +v),
        actionCategoricalAttributes: decodeObject(precomputedBandit.actionCategoricalAttributes ?? {}),
    };
}
//# sourceMappingURL=decoding.js.map